import { z } from "zod"

export const checklistKeywordSchema = z.object({
    type: z.string(),
    value: z.string(),
})
export type ChecklistKeyword = z.infer<typeof checklistKeywordSchema>

export const checklistPdfSchema = z.object({
    filename: z.string(),
    base64: z.string(),
})
export type ChecklistPdf = z.infer<typeof checklistPdfSchema>

export const postGenerateChecklistBodySchema = z
    .object({
        message: z.string().optional(),
        keywords: z.array(checklistKeywordSchema).optional(),
        pdf: checklistPdfSchema.optional(),
    })
    .refine((body) => !!body.message || !!body.pdf, {
        message: "Provide a message or a PDF.",
    })
export type POSTGenerateChecklistBody = z.infer<typeof postGenerateChecklistBodySchema>
